import React from 'react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary, #0a0a0f)', color: 'var(--text-primary, #e4e4f0)', padding: '60px 24px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: 48 }}>
          <Link to="/login" style={{ fontFamily: 'monospace', fontSize: 11, color: 'var(--text-dim, #666)', textDecoration: 'none', letterSpacing: '2px' }}>
            ← BACK TO SIGNAL
          </Link>
          <div style={{ fontFamily: 'monospace', fontSize: 10, color: 'var(--text-dim, #666)', letterSpacing: '3px', textTransform: 'uppercase', marginTop: 32, marginBottom: 8 }}>
            Legal
          </div>
          <h1 style={{ fontSize: 32, fontWeight: 600, marginBottom: 8 }}>Terms of Service</h1>
          <p style={{ color: 'var(--text-dim, #888)', fontSize: 13 }}>
            Effective Date: March 23, 2026 &nbsp;·&nbsp; GoLaunchNow Inc. &nbsp;·&nbsp; golaunchnow.io
          </p>
        </div>

        <style>{`
          .tos-section { margin-bottom: 40px; }
          .tos-section h2 { font-size: 18px; font-weight: 600; margin-bottom: 14px; color: #e4e4f0; }
          .tos-section p, .tos-section li { font-size: 14px; line-height: 1.8; color: #aaa; margin-bottom: 10px; }
          .tos-section ul { padding-left: 20px; }
          .tos-section li { margin-bottom: 6px; }
          a { color: #a78bfa; }
        `}</style>

        <div className="tos-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using GoLaunchNow, including the Signal performance tracking tool and the PALM VOC analysis
            engine, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not
            use our platform.
          </p>
        </div>

        <div className="tos-section">
          <h2>2. Description of Service</h2>
          <p>GoLaunchNow provides a two-layered social intelligence system:</p>
          <ul>
            <li>
              <strong style={{ color: '#e4e4f0' }}>Signal:</strong> Tracks your own content performance metrics and
              surfaces patterns to identify what content works.
            </li>
            <li>
              <strong style={{ color: '#e4e4f0' }}>PALM VOC:</strong> Mines comment threads on high-performing (viral)
              posts to extract market dialogue patterns and audience sophistication levels using AI.
            </li>
          </ul>
        </div>

        <div className="tos-section">
          <h2>3. Account Connections and Authorization</h2>
          <p>
            To use the service, you must authenticate your social media accounts (such as Instagram, Facebook, and
            TikTok) via OAuth. By connecting these accounts, you grant us permission to automatically fetch post
            metrics and comment datasets on your behalf. You represent and warrant that you have the legal right and
            authority to connect these accounts and access the associated data.
          </p>
        </div>

        <div className="tos-section">
          <h2>4. Acceptable Use and Third-Party Rules</h2>
          <p>
            Your use of GoLaunchNow must comply with the terms and conditions of the third-party platforms we integrate
            with (e.g., Meta, TikTok, LinkedIn). You agree not to:
          </p>
          <ul>
            <li>Use the platform to scrape data outside of the authorized API limits provided by connected platforms.</li>
            <li>
              Use the generated Voice of Customer (VOC) data for malicious purposes, harassment, or unauthorized
              surveillance.
            </li>
          </ul>
        </div>

        <div className="tos-section">
          <h2>5. AI Processing Disclaimer</h2>
          <p>
            The PALM VOC system utilizes the Claude API (Anthropic) to cluster data, analyze audience sophistication,
            and generate executive summaries. While this AI model is highly advanced, Signal does not guarantee the
            absolute accuracy, completeness, or reliability of the AI-generated intelligence briefs, recommendations,
            or emerging themes. All marketing actions taken based on these recommended actions are at your own risk.
          </p>
        </div>

        <div className="tos-section">
          <h2>6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Signal and its underlying infrastructure providers (including
            Hostinger and Anthropic) shall not be liable for any indirect, incidental, or consequential damages
            resulting from your use of the platform, your inability to access the platform, or the loss of social
            media connection tokens.
          </p>
        </div>

        <div className="tos-section">
          <h2>7. Modifications to the Service</h2>
          <p>
            We reserve the right to modify or discontinue any part of the service at any time. We may also adjust the
            "viral thresholds" that trigger automated comment analysis (such as absolute reach milestones or engagement
            rate percentiles) to ensure platform stability.
          </p>
        </div>

        <div className="tos-section">
          <h2>8. Contact Information</h2>
          <p>
            For any questions regarding these Terms of Service, please contact us at:
            {' '}<a href="mailto:privacy@golaunchnow.io">privacy@golaunchnow.io</a>.
          </p>
        </div>

        <div style={{ marginTop: 60, paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.06)',
                      display: 'flex', gap: 24, fontSize: 12, color: 'var(--text-dim, #666)' }}>
          <Link to="/privacy" style={{ color: 'inherit' }}>Privacy Policy</Link>
          <Link to="/terms"   style={{ color: 'inherit' }}>Terms of Service</Link>
          <a href="mailto:privacy@golaunchnow.io" style={{ color: 'inherit' }}>Contact</a>
        </div>

      </div>
    </div>
  );
}
